module.exports = __webpack_public_path__ + "img/ed8e3a2.png";